
import { TaskMsg, Feedback, Msg, Url_$reflection, Msg_$reflection, update as update_1, initialState, State_$reflection, Url } from "./Domain/Root.jsx";
import { map, ofArray, singleton, tail, head, isEmpty } from "./fable_modules/fable-library-js.5.0.0-alpha.22/List.js";
import { Route_$007CQuery$007C_$007C } from "./lib/Router.jsx";
import { some } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Option.js";
import { Union, Record } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { union_type, record_type, option_type, lambda_type, unit_type } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { BrowserEvent, BrowserEvent_$reflection } from "./Helpers.jsx";
import { concat, printf, toText } from "./fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { Cmd_ofEffect, Cmd_none } from "./fable_modules/Fable.Elmish.4.0.0/cmd.fs.js";
import { RouterModule_router, RouterModule_urlSegments } from "./lib/Router.jsx";
import { ProgramModule_mkProgram } from "./fable_modules/Fable.Elmish.4.0.0/program.fs.js";
import { Fragment, createElement } from "react";
import React from "react";
import { OnScreenKeyboard, Key_Create_Z39EE07B2, digitalKeyboard, Key_confirm, Key_next_1505, Key_ok_1505, Key_withEnabled } from "./components/custom/OnScreenKeyboard.jsx";
import { State__get_CanClear, State__get_Format, Msg as Msg_1 } from "./Domain/Aufgaben/BruchKuerzen.jsx";
import { DecimalInput__get_HasValue, IntInput__get_HasValue } from "./Domain/Input.jsx";
import { fromAusdruck } from "./components/custom/MathSvg.jsx";
import { State__get_CanClear as State__get_CanClear_1, State__get_Format as State__get_Format_1, Msg as Msg_2 } from "./Domain/Aufgaben/BruchZuDezimal.jsx";
import { State__get_Format as State__get_Format_2, State__get_ZielEinheit, State__get_StartEinheit, State__get_CanKommaRechts, State__get_CanKommaLinks, Msg as Msg_3 } from "./Domain/Aufgaben/Konvertieren.jsx";
import { singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Seq.js";
import { AlertDialogTitle, AlertDialogHeader, AlertDialogFooter, AlertDialogDescription, AlertDialogContent, AlertDialogCancel, AlertDialogAction, AlertDialog } from "@/components/ui/alert-dialog";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { createObj, equals } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { motion } from "motion/react";
import { AppSidebar } from "@/components/custom/app-sidebar";
import { React_useElmish_Z6C327F2E } from "./fable_modules/Feliz.UseElmish.4.1.0/UseElmish.fs.js";
import { defaultOf as defaultOf_1 } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { Interop_setKeyOnObj } from "./fable_modules/Feliz.3.1.1/Helper/Helpers.fs.js";
import { AusdruckModule_ofDecimal, Ausdruck, AusdruckModule_ofInt } from "./Domain/Ausdruck.jsx";
import { fromParts } from "./fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";

export function MVU_parseUrl(url) {
    let matchResult, taskType;
    if (!isEmpty(url)) {
        const activePatternResult = Route_$007CQuery$007C_$007C(head(url));
        if (activePatternResult != null) {
            if (!isEmpty(activePatternResult)) {
                if (head(activePatternResult)[0] === "task") {
                    if (isEmpty(tail(activePatternResult))) {
                        if (isEmpty(tail(url))) {
                            matchResult = 1;
                            taskType = head(activePatternResult)[1];
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Url(0, []);
        case 1:
            return new Url(1, [taskType]);
        default:
            return new Url(0, []);
    }
}

export function MVU_logger(message) {
    console.log(some(message));
}

export class MVU_State extends Record {
    constructor(Root, AppUpdate) {
        super();
        this.Root = Root;
        this.AppUpdate = AppUpdate;
    }
}

export function MVU_State_$reflection() {
    return record_type("MatheApp.UI.MVU.State", [], MVU_State, () => [["Root", State_$reflection()], ["AppUpdate", option_type(lambda_type(unit_type, unit_type))]]);
}

export const MVU_initialState = new MVU_State(initialState, undefined);

export function MVU_domainUpdate(msg, state) {
    return new MVU_State(update_1((message) => {
        MVU_logger(message);
    }, msg, state.Root), state.AppUpdate);
}

export class MVU_AppMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DomainMsg", "BrowserEventMsg", "UrlChanged", "ConfirmUpdate", "DismissUpdate"];
    }
}

export function MVU_AppMsg_$reflection() {
    return union_type("MatheApp.UI.MVU.AppMsg", [], MVU_AppMsg, () => [[["Item", Msg_$reflection()]], [["Item", BrowserEvent_$reflection()]], [["Item", Url_$reflection()]], [], []]);
}

export function MVU_update(msg, state) {
    console.log(some(toText(printf("Updating with message: %A"))(msg)));
    let matchResult;
    switch (msg.tag) {
        case 0: {
            matchResult = 0;
            break;
        }
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            break;
        }
        case 3: {
            if (state.AppUpdate != null) {
                matchResult = 3;
            }
            else {
                matchResult = 5;
            }
            break;
        }
        default:
            if (state.AppUpdate != null) {
                matchResult = 4;
            }
            else {
                matchResult = 5;
            }
    }
    switch (matchResult) {
        case 0:
            return [MVU_domainUpdate(msg.fields[0], state), Cmd_none()];
        case 1:
            return [new MVU_State(state.Root, msg.fields[0].fields[0]), Cmd_none()];
        case 2: {
            const url = msg.fields[0];
            if (url.tag === 0) {
                return [MVU_domainUpdate(new Msg(2, []), state), Cmd_none()];
            }
            else {
                return [MVU_domainUpdate(new Msg(3, [url.fields[0]]), state), Cmd_none()];
            }
        }
        case 3: {
            const update = state.AppUpdate;
            return [new MVU_State(state.Root, undefined), Cmd_ofEffect((_arg) => {
                update();
            })];
        }
        case 4:
            return [new MVU_State(state.Root, undefined), Cmd_none()];
        default:
            return [state, Cmd_none()];
    }
}

export function MVU_init() {
    const url_1 = MVU_parseUrl(RouterModule_urlSegments(window.location.hash, 1));
    return [MVU_update(new MVU_AppMsg(0, [(url_1.tag === 1) ? (new Msg(3, [url_1.fields[0]])) : (new Msg(2, []))]), MVU_initialState)[0], Cmd_ofEffect((dispatch) => {
        BrowserEvent.subscribe((evt) => {
            dispatch(new MVU_AppMsg(1, [evt]));
        });
    })];
}

export function MVU_view(_arg, _arg_1) {
}

export function MVU_program() {
    return ProgramModule_mkProgram(MVU_init, MVU_update, (arg00$0040_1, arg10$0040) => {
        MVU_view(arg00$0040_1, arg10$0040);
    });
}

export function App_instructions(text) {
    return             <h3 className="mb-4 p-4 bg-secondary text-secondary-foreground rounded-lg">
                {text}
            </h3>
            ;
}

export function App_BruchKuerzen_BruchKuerzenView($props) {
    const model = $props.model;
    const dispatch = $props.dispatch;
    const ok = (isEnabled) => Key_withEnabled(isEnabled, Key_ok_1505(new Msg_1(2, [])));
    const next = Key_next_1505(new Msg_1(2, []));
    const vollständig = Key_confirm("Vollständig", new Msg_1(0, [true]));
    const additionalKey = (model.tag === 1) ? ok(IntInput__get_HasValue(model.fields[0].Zähler)) : ((model.tag === 2) ? ok(IntInput__get_HasValue(model.fields[0].Nenner)) : ((model.tag === 3) ? next : (IntInput__get_HasValue(model.fields[0].Faktor) ? ok(true) : vollständig)));
    return                 <>
                {App_instructions((model.tag === 1) ? "Gib den neuen Zähler ein:" : ((model.tag === 2) ? "Gib den neuen Nenner ein:" : ((model.tag === 3) ? "Aufgabe abgeschlossen" : "Gib einen Kürzungsfaktor ein:")))}
                {fromAusdruck(State__get_Format(model))}
                {digitalKeyboard(dispatch, (Item) => (new Msg_1(1, [Item])), State__get_CanClear(model), false, singleton(additionalKey))}
                </>
                ;
}

export function App_BruchZuDezimal_BruchZuDezimalView($props) {
    const model = $props.model;
    const dispatch = $props.dispatch;
    const next = Key_next_1505(new Msg_2(1, []));
    const additionalKey = (model.tag === 1) ? next : Key_withEnabled(DecimalInput__get_HasValue(model.fields[0].Dezimal), Key_ok_1505(new Msg_2(1, [])));
    return                 <>
                {App_instructions("Wandle den Bruch in eine Dezimalzahl um:")}
                {fromAusdruck(State__get_Format_1(model))}
                {digitalKeyboard(dispatch, (Item) => (new Msg_2(0, [Item])), State__get_CanClear_1(model), true, singleton(additionalKey))}
                </>
                ;
}

export function App_Konvertieren_KonvertierenView($props) {
    const model = $props.model;
    const dispatch = $props.dispatch;
    console.log(some(toText(printf("Rendering KonvertierenView with model: %A"))(model)));
    const links = Key_Create_Z39EE07B2("←,", new Msg_3(0, []), undefined, undefined, undefined, undefined, State__get_CanKommaLinks(model), undefined, true);
    const rechts = Key_Create_Z39EE07B2(",→", new Msg_3(1, []), undefined, undefined, undefined, undefined, State__get_CanKommaRechts(model), undefined, true);
    const ok = Key_ok_1505(new Msg_3(2, []));
    const next = Key_next_1505(new Msg_3(2, []));
    const keys = toList(delay(() => append((model.tag === 1) ? singleton_1(next) : singleton_1(ok), delay(() => append(singleton_1(links), delay(() => singleton_1(rechts)))))));
    const einheit = (_arg) => {
        if (_arg === "") {
            return "Dezimalzahl";
        }
        else {
            return _arg;
        }
    };
    return                 <>
                {App_instructions(`Konvertiere von ${einheit(State__get_StartEinheit(model))} nach ${einheit(State__get_ZielEinheit(model))}:`)}
                {fromAusdruck(State__get_Format_2(model))}
                {createElement(OnScreenKeyboard, {
        columns: 2,
        dispatch: dispatch,
        keys: keys,
    })}
                </>
                ;
}

function App_op_GreaterMinusGreater(ctor, dispatch) {
    return (arg_2) => dispatch(new MVU_AppMsg(0, [new Msg(0, [ctor(arg_2)])]));
}

export function App_UpdateDialog($props) {
    const dispatch = $props.dispatch;
    return             <AlertDialog open={true}>
                <AlertDialogContent>
                    <AlertDialogHeader>
                        <AlertDialogTitle>Update verfügbar</AlertDialogTitle>
                        <AlertDialogDescription>
                            Eine neue Version der Anwendung ist verfügbar. Bitte aktualisiere die Seite, um die neueste Version zu laden.
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogAction onClick={(_arg) => dispatch(new MVU_AppMsg(3, []))}>
                            Seite neu laden
                        </AlertDialogAction>
                        <AlertDialogCancel onClick={(_arg_1) => dispatch(new MVU_AppMsg(4, []))}>
                            Später
                        </AlertDialogCancel>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
            ;
}

export function App_HeaderBar($props) {
    const title = $props.title;
    return             <header className="fixed w-full flex h-12 items-center gap-4 px-2 bg-foreground text-accent">
                <SidebarTrigger />
                <h2 className="text-lg font-semibold">{title}</h2>
            </header>
            ;
}

export function App_FeedbackOverlay($props) {
    const feedback = $props.feedback;
    const dispatch = $props.dispatch;
    const patternInput = (feedback.tag === 1) ? ["bg-green-500/90", "fa-check"] : ((feedback.tag === 2) ? ["bg-red-500/90", "fa-times"] : ["", ""]);
    const containerCls = concat("text-[30em] ", patternInput[0], ..." flex flex-col h-full w-full fixed top-0 left-0 items-center justify-center pointer-events-none");
    const iconCls = concat("fa ", patternInput[1], ..." text-white");
    if (equals(feedback, new Feedback(0, []))) {
        return defaultOf();
    }
    else {
        return                 <motion.div key={feedback} initial={{
            opacity: 1,
        }} animate={{
            opacity: 0,
            transition: {
                delay: 0.2,
                duration: 0.3,
                ease: "ease-in",
            },
        }} 
                    className={containerCls}
                    onAnimationComplete={() => dispatch(new MVU_AppMsg(0, [new Msg(4, [])]))}>
                    <div className={iconCls}></div>
                </motion.div>
                ;
    }
}

export function App_Layout($props) {
    const view = $props.view;
    const title = $props.title;
    const feedback = $props.feedback;
    const hasUpdate = $props.hasUpdate;
    const dispatch = $props.dispatch;
    return             <>
                {hasUpdate ? createElement(App_UpdateDialog, {
        dispatch: dispatch,
    }) : defaultOf()}
                <SidebarProvider defaultOpen={false}>
                    <AppSidebar />
                    <main className="w-full">
                        {createElement(App_HeaderBar, {
        title: title,
    })}
                        <div className="p-4 mt-12">
                            {view}
                        </div>
                        {createElement(App_FeedbackOverlay, {
        dispatch: dispatch,
        feedback: feedback,
    })}
                    </main>
                </SidebarProvider>
            </>
            ;
}

export function App_App() {
    let s_1, s_2, s, elements;
    const patternInput = React_useElmish_Z6C327F2E(MVU_program, undefined, undefined);
    const state = patternInput[0];
    const dispatch = patternInput[1];
    let patternInput_1;
    const matchValue = state.Root.CurrentTask;
    patternInput_1 = ((matchValue != null) ? ((matchValue.tag === 1) ? ((s_1 = matchValue.fields[0], ["Bruch zu Dezimal", createElement(App_BruchZuDezimal_BruchZuDezimalView, {
        dispatch: App_op_GreaterMinusGreater((Item_2) => (new TaskMsg(1, [Item_2])), dispatch),
        model: s_1,
    })])) : ((matchValue.tag === 2) ? ((s_2 = matchValue.fields[0], ["Konvertiere", createElement(App_Konvertieren_KonvertierenView, {
        dispatch: App_op_GreaterMinusGreater((Item_3) => (new TaskMsg(2, [Item_3])), dispatch),
        model: s_2,
    })])) : ((s = matchValue.fields[0], ["Kürze den Bruch", createElement(App_BruchKuerzen_BruchKuerzenView, {
        dispatch: App_op_GreaterMinusGreater((Item_1) => (new TaskMsg(0, [Item_1])), dispatch),
        model: s,
    })])))) : ["?", defaultOf()]);
    const hasUpdate = state.AppUpdate != null;
    let router;
    const props_1 = createObj(ofArray([["hashMode", 1], ["onUrlChanged", (arg_1) => {
        dispatch(new MVU_AppMsg(2, [MVU_parseUrl(arg_1)]));
    }], (elements = singleton(createElement(App_Layout, {
        dispatch: dispatch,
        hasUpdate: hasUpdate,
        feedback: state.Root.Feedback,
        title: patternInput_1[0],
        view: patternInput_1[1],
    })), ["application", createElement(Fragment, defaultOf_1(), ...elements)])]));
    if (!((props_1 !== null && typeof props_1 === "object" && !Array.isArray(props_1)))) {
        console.error(some("React.memoRender: props must be an object."));
    }
    router = createElement(RouterModule_router, Interop_setKeyOnObj(undefined, props_1));
    const bruch2 = new Ausdruck(3, [AusdruckModule_ofInt(1234), AusdruckModule_ofInt(34)]);
    const gleich1 = new Ausdruck(6, [AusdruckModule_ofInt(123), AusdruckModule_ofDecimal(fromParts(12332, 0, 0, false, 2))]);
    const gleich2 = new Ausdruck(7, [AusdruckModule_ofInt(123), AusdruckModule_ofInt(32), bruch2]);
    const dezimal = new Ausdruck(8, [AusdruckModule_ofInt(2322), "mm"]);
    const bruch1 = new Ausdruck(3, [AusdruckModule_ofInt(1221232), dezimal]);
    const einheiten_1 = new Ausdruck(9, [map((e) => (new Ausdruck(6, [new Ausdruck(8, [AusdruckModule_ofInt(1234), e]), AusdruckModule_ofInt(1)])), ofArray(["m", "m²", "m³", "dm²", "km", "cm", "mm³", "@"]))]);
    const doppelbruchUnten = new Ausdruck(3, [AusdruckModule_ofInt(2), new Ausdruck(3, [AusdruckModule_ofInt(4321), new Ausdruck(8, [AusdruckModule_ofInt(34), "cm"])])]);
    const doppelbruchOben = new Ausdruck(3, [new Ausdruck(3, [AusdruckModule_ofInt(4321), AusdruckModule_ofInt(34)]), AusdruckModule_ofInt(2)]);
    const normalerBruch = new Ausdruck(3, [AusdruckModule_ofInt(4321), AusdruckModule_ofInt(34)]);
    fromAusdruck(new Ausdruck(9, [singleton(einheiten_1)]));
    return router;
}

